import React from 'react';
import classes from './PrimaryBtn.module.scss';
import { AccessibilityButton } from '@skillz/accessibility';

const PrimaryButton = ({ onClick, dropClass, disabled, btnText, large, color, children }) => {
  
    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    return (
        <AccessibilityButton
            style={{ background: color }}
            className={`${classes.PrimaryButton} ${disabled && classes.Disabled} ${dropClass}`}
            onClick={handleClick}>
            {children || btnText}
        </AccessibilityButton>
    );
};

export default PrimaryButton;
